<template>
  <div>
    <div style="margin-bottom: 15px">
      <span>选择学校：</span>
      <a-select v-model="bizOrgId" :allowClear="true" style="width: 15%">
        <a-select-option v-for="bizOrg in bizOrgList" :value="bizOrg.id" :key="bizOrg.id">
          {{ bizOrg.name }}
        </a-select-option>
      </a-select>
      <span style="margin-left: 12px">名称、编码、位置：</span>
      <a-input allow-clear v-model="keyword" style="width: 10%"/>
      <a-button type="primary" icon="search" style="margin-left: 15px" @click="handleSearch">查询</a-button>
    </div>
    <a-divider />
    <div style="margin-bottom: 15px">
      <a-button :disabled="true" icon="plus" type="primary" style="margin-left: 15px" @click="handleSearch">新增</a-button>
    </div>

    <a-table
        :columns="columns"
        :data-source="rows"
        :pagination="pagination"
        @change="handleTableChange"
        size="middle"
        :loading="loading"
        rowKey="id"
        bordered>
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
      <template slot="qrcode" slot-scope="text, record">
        <a-button :disabled="true" style="padding: 0 3px;" type="link">
          <span style="margin-left: 2px">查看</span>
        </a-button>
      </template>
      <template slot="action" slot-scope="text, record">
        <a-button :disabled="true" style="padding: 0 3px;" type="link">
          <a-icon type="edit" /><span style="margin-left: 2px">编辑</span>
        </a-button>
        <a-divider type="vertical" />
        <a-button style="padding: 0 3px;" type="link" @click="$refs.cabinetCellList.showModal(record)">
          <a-icon type="plus-circle" /><span style="margin-left: 2px">柜格管理</span>
        </a-button>
      </template>
    </a-table>
    <cabinet-cell-list ref="cabinetCellList" />
  </div>
</template>

<script>
import bizOrgService from '@/service/bizOrg'
import cabinetService from '@/service/cabinet'
import CabinetCellList from "@/pages/BizOrgManage/CabinetCellList.vue";

export default {
  name: "EmpList",
  components: {CabinetCellList},
  data() {
    return {
      columns: [
        {title: '#', width: "8%", scopedSlots: {customRender: 'serial'}, align: 'center'},
        {title: '学校', width: "20%", dataIndex: 'bizOrgName', align: 'center'},
        {title: '编码', width: "15%", dataIndex: 'code', align: 'center'},
        {title: '放置位置', width: "25%", dataIndex: 'location', align: 'center'},
        {title: '创建时间', width: "17%", dataIndex: 'created', align: 'center'},
        {title: '操作', width: "20%", dataIndex: 'action', scopedSlots: {customRender: 'action'}, align: 'center'}
      ],
      rows: [],
      pagination: {},
      bizOrgList: [],

      keyword: '',
      bizOrgId: null,
      loading: false
    };
  },
  mounted() {
    let params = {
      current: 1,
      size: 10,
    }
    this.fetch(params)

    bizOrgService.queryBriefList().then((res) => {
      this.bizOrgList = res.data
    })
  },
  methods: {
    handleTableChange(pagination) {
      this.fetch(pagination)
    },
    handleSearch() {
      this.fetch()
    },
    fetch(page) {
      let params = {
        current: page ? page.current : 1,
        size: page ? page.size : 10,
        keyword: this.keyword,
        bizOrgId: this.bizOrgId
      }
      this.loading = true
      cabinetService.queryPage(params).then((res) => {
        const pagination = {...this.pagination};
        this.rows = res.data.records
        pagination.current = res.data.current
        pagination.total = res.data.total
        pagination.size = res.data.size + ''
        pagination.showTotal = (total, range) => {
          return `${range[0]}-${range[1]} 总计 ${total} 条`
        }
        this.pagination = pagination
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
  }
}
</script>
